import React from 'react';
import PropTypes from 'prop-types';

import ReclamationsTable from './ReclamationsTable';
import ReclamationsRetourPlateformeTable from './ReclamationsRetourPlateformeTable';


import { ReclamationFiltre } from 'constants.js';


const ReclamationsSearchResults = ({ filtre }) => {

    if (filtre === ReclamationFiltre.RetourPlateforme) {
        return (<ReclamationsRetourPlateformeTable/>);
    }
    return (<ReclamationsTable/>);

};

ReclamationsSearchResults.propTypes = {
    filtre: PropTypes.number.isRequired
};

export default ReclamationsSearchResults;
